export default __webpack_public_path__ + "ellipse.asset.f687238641dd6680b102dd62e911df1f.svg";